/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SandZ, SandZInterface } from "../SandZ";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_destinationList",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_balanceList",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class SandZ__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _destinationList: string[],
    _balanceList: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SandZ> {
    return super.deploy(
      _destinationList,
      _balanceList,
      overrides || {}
    ) as Promise<SandZ>;
  }
  getDeployTransaction(
    _destinationList: string[],
    _balanceList: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _destinationList,
      _balanceList,
      overrides || {}
    );
  }
  attach(address: string): SandZ {
    return super.attach(address) as SandZ;
  }
  connect(signer: Signer): SandZ__factory {
    return super.connect(signer) as SandZ__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SandZInterface {
    return new utils.Interface(_abi) as SandZInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): SandZ {
    return new Contract(address, _abi, signerOrProvider) as SandZ;
  }
}
